import React from 'react';

export default function BottomArrow({props, height = 24, width = 24 , fill = 'currentColor'}) {
  return (
    <svg
    style={{marginLeft : '2px '}}
      height={height}
      width={width}
      {...props}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.55117 5.56836L6.62617 9.64336C7.10742 10.1246 7.89492 10.1246 8.37617 9.64336L12.4512 5.56836"
        stroke={fill}
        strokeWidth="1"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
